import PropTypes from 'prop-types';
import React from 'react';
import {observer} from 'mobx-react';

import BannerAdV2 from 'directory/v2/components/BannerAdV2.js';
import {DirectoryStoreContextV2} from 'core/stores/RootStore.js';

export default
@observer
class BannerAdsListV2 extends React.Component {
    static contextType = DirectoryStoreContextV2;

    static propTypes = {
        forHealthFund: PropTypes.bool,
    };

    static defaultProps = {
        forHealthFund: false,
    };

    collectBannerAds() {
        const {
            bannerAds,
            healthFundBannerAds,
            regularBannerAds,
            rootStore: {
                healthFundStore: {healthFund},
            },
        } = this.context;
        if (healthFund?.combineBannerAdsDisplay) {
            return bannerAds;
        } else {
            return this.props.forHealthFund
                ? healthFundBannerAds
                : regularBannerAds;
        }
    }

    render() {
        const {
            bannerAdsHaveLoaded,
            locationSearchAPI: {isLoading},
            searchResultsError,
            specialty,
            renderModal,
            rootStore: {
                healthFundStore: {healthFund},
                paramStore: {isMobileOrTablet, isClient, isReferrals},
            },
            telehealthDirectory,
        } = this.context;
        const bannerAds = bannerAdsHaveLoaded && this.collectBannerAds();

        if (isLoading) {
            return null;
        }

        if (healthFund?.combineBannerAdsDisplay && this.props.forHealthFund) {
            return null;
        }

        if (!bannerAds.length || searchResultsError) {
            return null;
        }

        return (
            <section className="partners">
                <ul>
                    {bannerAds.map((data) => {
                        const baProps = {
                            ...data,
                            healthFund,
                            isClient,
                            isMobileOrTablet,
                            isReferrals,
                            renderModal,
                            telehealthDirectory,
                            hasMedicalSpecialty: specialty.isMedical,
                        };
                        return <BannerAdV2 {...baProps} key={data.id} />;
                    })}
                </ul>
            </section>
        );
    }
}
